
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contract/payment",
      function () {
        return require("private-next-pages/contract/payment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contract/payment"])
      });
    }
  